export const searchData = (e, projects, setSearchResults, setProspectProfile) => {
    setProspectProfile(false)
    setSearchResults(
        projects?.filter(dataContainsTerm(e))
    );
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.ProspectName.toString().toLowerCase().includes(word) &&
            startsWith(data.ProspectName.toString().toLowerCase(), word)) {
                return true;
        } else if (data.ProspectCompany.toString().toLowerCase().includes(word) || 
            startsWith(data.ProspectCompany.toString().toLowerCase(), word)) {
                return true;
        } 
        
        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}